<template>
  <div v-if="loading" class="mainLoader">
    <div class="d-flex justify-content-center mb-3">
      <b-spinner
        style="width: 150px; height: 150px;"
        type="grow"
        variant="primary"
      ></b-spinner>
    </div>
  </div>
</template>
<script>
import store from "@/store";
export default {
  computed: {
    loading: () => store.state.loading
  }
};
</script>
